module.exports = __webpack_public_path__ + "media/vidos.b8fa6062.ogg";